/** Days after purchase during which the customer can request a full refund. */
export const REFUND_DAYS = 30;

export const OFFER_PERIOD = {
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
  QUINQUENNIAL: "QUINQUENNIAL",
};

/** Resolve period to MONTHLY, YEARLY, or QUINQUENNIAL (defaults to YEARLY). */
export function normalizeOfferPeriod(period) {
  const p = String(period || "").trim().toUpperCase();

  if (p === OFFER_PERIOD.MONTHLY) return OFFER_PERIOD.MONTHLY;
  if (p === OFFER_PERIOD.QUINQUENNIAL) return OFFER_PERIOD.QUINQUENNIAL;
  return OFFER_PERIOD.YEARLY;
}

/** Human-readable access length, e.g. "30 dias", "1 ano", "5 anos". */
export function getAccessDurationLabel(period) {
  switch (normalizeOfferPeriod(period)) {
    case OFFER_PERIOD.MONTHLY:
      return "30 dias";
    case OFFER_PERIOD.QUINQUENNIAL:
      return "5 anos";
    case OFFER_PERIOD.YEARLY:
    default:
      return "1 ano";
  }
}

/** Subtitle under the offer headline. */
export function getAccessSubtitle(period) {
  return `Acesso imediato a todos os cursos durante ${getAccessDurationLabel(period)}.`;
}

/** Benefit bullet for access duration. */
export function getAccessBenefitLabel(period) {
  return `Acesso por ${getAccessDurationLabel(period)} - atualizações inclusas`;
}

/** Short plan label for account/billing UI. */
export function getCycleLabel(period) {
  switch (normalizeOfferPeriod(period)) {
    case OFFER_PERIOD.MONTHLY:
      return "Mensal";
    case OFFER_PERIOD.QUINQUENNIAL:
      return "Quinquenal";
    case OFFER_PERIOD.YEARLY:
    default:
      return "Anual";
  }
}

/** Whether this cycle supports canceling automatic renewal. */
export function canHaveRenewal(period) {
  const key = normalizeOfferPeriod(period);
  return (
    key === OFFER_PERIOD.MONTHLY ||
    key === OFFER_PERIOD.YEARLY ||
    key === OFFER_PERIOD.QUINQUENNIAL
  );
}
